import type { TDevToolbarFormData, IDevToolbarFormDataApi, TDebugFeature } from '../../models';
import type { TFeatureName } from '~/features/feature-flags';

import { EFeatureName, EFeatureValue } from '~/features/feature-flags';
import { Form, FormField } from '#shared/form';
import { EDebugFeature } from '../../models';

export class _DevToolBarForm extends Form<TDevToolbarFormData> {
  private currentApiSnapshot: IDevToolbarFormDataApi['api'];

  constructor() {
    const ffFieldsObj = {} as Record<TFeatureName, FormField<EFeatureValue>>;
    Object.values(EFeatureName).forEach(
      (name) => (ffFieldsObj[name] = new FormField<EFeatureValue>(EFeatureValue.UNSET))
    );

    const debugFieldsObj = {} as Record<TDebugFeature, FormField<boolean>>;
    Object.values(EDebugFeature).forEach(
      (name) => (debugFieldsObj[name] = new FormField<boolean>(false))
    );

    super({
      api: new FormField<IDevToolbarFormDataApi['api']>('auto'),
      ...ffFieldsObj,
      ...debugFieldsObj,
    });

    this.currentApiSnapshot = this.formData.api.value;
  }

  override reset(initStates: TDevToolbarFormData) {
    (Object.keys(initStates) as Array<keyof TDevToolbarFormData>).forEach((key) => {
      this.formData[key].value = initStates[key];
    });

    this.currentApiSnapshot = this.formData.api.value;
  }

  public get isAPISwitched() {
    return this.formData.api.value !== this.currentApiSnapshot;
  }
}
